<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.BOOKMAKER.SELECT_BOOKMAKER_ID_TO_CHANGE"
    :handler="() => $refs.modal.show()"
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.BOOKMAKER.REQUEST_BOOKMAKER_ID_CHANGE"
    :handler="() => $refs.modal.hide()"
  />
  <DialogComponent ref="modal" type="modal" noInnerPadding>
    <div class="p-6">
      <h2 class="text-xl font-bold text-gray-900 mb-6">Sélectionnez l'ID à changer</h2>

      <div class="space-y-3">
        <div
          v-for="(bookmaker, key) in $constants.BOOKMAKER.INFOS"
          :key="key"
          @click="
            () => {
              $bus.emit(
                $constants.EVENTS.BOOKMAKER.REQUEST_BOOKMAKER_ID_CHANGE,
                {
                  bookmaker: key
                }
              );
            }
          "
          class="flex items-center gap-4 p-4 rounded-xl bg-white border border-gray-200 cursor-pointer hover:border-primary hover:bg-gray-50 transition-all active:bg-gray-100"
        >
          <div class="w-14 h-14 bg-gray-100 rounded-xl flex items-center justify-center flex-shrink-0">
            <ImgComponent :src="bookmaker.logo" class="w-10 h-10 object-contain" />
          </div>

          <div class="flex-1 min-w-0">
            <div class="font-semibold text-gray-900">
              {{ bookmaker.name }}
            </div>
          </div>

          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 18l6-6-6 6"/>
          </svg>
        </div>
      </div>
    </div>
  </DialogComponent>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BookmakerAccountToSetSelecot'
});
</script>
